import Vue from "vue";

import store from "@/store";

import chamaileonFrontendModules from "@edmdesigner/chamaileon-frontend-modules";
import "@edmdesigner/chamaileon-frontend-modules/dist/chamaileon-frontend-modules.css";

Vue.use(chamaileonFrontendModules, { store });

export default chamaileonFrontendModules;
